module.exports = __webpack_public_path__ + "img/shopify.fd06e21f.svg";